























































































import AulaButton from '../../../shared/components/AulaButton.vue';
import { PropType } from 'vue';
import { PostModel } from '../../../shared/models/post.model';
import { AddCommentRequest } from '../../../shared/models/requests/addComment.request';
import { commentTypes } from '../../../shared/enums/commentTypes';
import { commentService } from '../../../shared/services/api/comment.service';
import { mapActions, mapGetters } from 'vuex';
import { types } from '../../store/types/types.js';
import { GetCommentsRequest } from '../../../shared/models/requests/getComments.request';
import { CommentModel } from '../../../shared/models/comment.model';
import PostComment from './PostComment.vue';
import Icon from '../../../shared/components/Icon.vue';
import { iconClassEnum } from '../../../shared/enums/iconClassEnum';
import CommentTextarea from '../comments/CommentTextarea.vue';
import { InstitutionModel } from '../../../shared/models/institution.model';
import { portalRoles } from '../../../shared/enums/portalRoles';
import { notificationAreas } from '../../../shared/enums/notificationAreas';
import { notificationTypes } from '../../../shared/enums/notificationTypes';
import { notificationEventTypes } from '../../../shared/enums/notificationEventTypes';
import { useNotificationStore } from '../../../shared/stores/notification';

const COMMENTS_LIMIT = 5;
export default {
  components: { CommentTextarea, Icon, PostComment, AulaButton },
  props: {
    post: { type: Object as PropType<PostModel>, required: true },
    includesReportedComments: { type: Boolean, default: false },
    previewMode: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    highlightedCommentId: { type: Number, default: null },
  },
  data() {
    return {
      isExpanded: false,
      isLoading: false,
      isSubmitting: false,
      index: 0,
      comments: [] as CommentModel[],
      commentText: '',
      selectedProfile: null as InstitutionModel,
      newCommentNotifications: [],
    };
  },
  computed: {
    ...mapGetters({
      institutions: types.GET_INSTITUTIONS,
      activeInstitutionCodes: types.GET_ACTIVE_INSTITUTIONS,
      notifications: types.GET_NOTIFICATIONS,
    }),
    notificationStore() {
      return useNotificationStore();
    },
    firstNewCommentIndex() {
      return this.comments.findIndex(comment =>
        this.newCommentNotifications.some(
          notification =>
            notification.notificationArea == notificationAreas.POSTS &&
            notification.notificationType === notificationTypes.BADGE &&
            notification.commentId == comment.id &&
            notification.notificationEventType === notificationEventTypes.NEW_POST_COMMENT
        )
      );
    },
    newCommentsCount() {
      return this.newCommentNotifications.length;
    },
    hasNewComments() {
      return this.newCommentsCount > 0;
    },
    canSelectInstitution() {
      return this.post.relatedProfiles.length > 1 && this.selectedProfile?.role === portalRoles.EMPLOYEE;
    },
    canComment() {
      return this.post.canCurrentUserComment && !this.previewMode;
    },
    iconClassEnum() {
      return iconClassEnum;
    },
    numberOfCommentsText() {
      return this.$tc('label.number_of_comments', this.post.commentCount);
    },
    numberOfUnreadText() {
      return this.$tc('label.number_of_unread', this.newCommentsCount);
    },
    institutionProfileId() {
      const relatedInstitution = this.selectedProfile?.institution;
      const institutionProfile = this.institutions.find(
        institution => institution.institutionCode === relatedInstitution?.institutionCode
      );
      return institutionProfile?.institutionProfileId || null;
    },
    totalCount() {
      let count = 0;
      for (const comment of this.comments) {
        count = count + 1 + comment.commentCount;
      }
      return count;
    },
    hasMoreComments() {
      return this.totalCount < this.post.commentCount;
    },
  },
  mounted() {
    this.selectedProfile = this.post.relatedProfiles[0];
    this.newCommentNotifications = this.notifications.filter(
      notification =>
        notification.notificationArea == notificationAreas.POSTS &&
        notification.notificationType === notificationTypes.BADGE &&
        notification.postId == this.post.id &&
        notification.notificationEventType === notificationEventTypes.NEW_POST_COMMENT
    );
  },
  methods: {
    ...mapActions({
      deleteNotifications: types.DELETE_NOTIFICATIONS,
    }),
    selectProfile(profile) {
      this.selectedProfile = profile;
    },
    handleCommentExpandClick() {
      this.expandCommentArea();
      this.clearUnreadNotifications();
    },
    async clearUnreadNotifications() {
      this.notificationStore.setLoading(true);
      await this.deleteNotifications({ notifications: this.newCommentNotifications });
      this.notificationStore.setLoading(false);
    },
    async expandCommentArea() {
      this.isExpanded = true;
      const firstLimit = Math.max(this.newCommentsCount, COMMENTS_LIMIT);
      this.comments = await this.getComments({ limit: firstLimit });
    },
    handleWriteCommentClicked() {
      if (!this.isExpanded) {
        this.expandCommentArea();
      }
      this.$nextTick(() => {
        this.$refs.textarea.focus();
      });
    },
    async handleAddComment() {
      const newComment = await this.addComment();
      this.comments.push(newComment);
      this.resetInput();
    },
    async getComments({ limit = COMMENTS_LIMIT } = {}) {
      const params: GetCommentsRequest = {
        parentType: commentTypes.POST,
        parentId: this.post.id,
        limit,
        startIndex: this.index,
        includeReportedComments: this.includesReportedComments,
      };
      this.isLoading = true;
      const { comments } = await commentService.getComments(params);
      this.isLoading = false;
      return comments;
    },
    async addComment() {
      const payload: AddCommentRequest = {
        creatorInstProfileId: this.institutionProfileId,
        commentableItem: {
          id: this.post.id,
          type: commentTypes.POST,
        },
        content: this.commentText,
      };
      this.isSubmitting = true;
      const comment = await commentService.addComment(payload);
      this.isSubmitting = false;
      return comment;
    },
    async loadPreviousComments() {
      this.index = this.comments.length;
      const previousComments = await this.getComments();
      this.comments.unshift(...previousComments);
    },
    resetInput() {
      this.commentText = '';
    },
  },
};
